import { Resource } from 'i18next'
import { getGlobalI18nInstance, I18nDocument } from './handleI18nInstance'

const globalInstance = getGlobalI18nInstance()

interface RegisterI18nResourcesOptions {
  namespace: string
  resources: { [locale: string]: I18nDocument | Resource }
}

const DEV =
  // eslint-disable-next-line no-process-env
  typeof process !== 'undefined' && process?.env?.NODE_ENV === 'development'

export const registerI18nResources: ({
  namespace,
  resources, // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: RegisterI18nResourcesOptions) => any = ({
  namespace,
  resources,
}: RegisterI18nResourcesOptions) => {
  Object.keys(resources).forEach((locale) => {
    // In development, always replace resource bundles to enable hot reloading
    if (DEV) {
      // Remove existing bundle first, then add new one
      if (globalInstance.hasResourceBundle(locale, namespace)) {
        globalInstance.removeResourceBundle(locale, namespace)
      }
      globalInstance.addResourceBundle(
        locale,
        namespace,
        resources[locale],
        true,
        true,
      )

      // Emit event to trigger re-renders
      globalInstance.emit('loaded', [locale])
    } else if (!globalInstance.hasResourceBundle(locale, namespace)) {
      globalInstance.addResourceBundle(locale, namespace, resources[locale])
    }
  })

  return globalInstance
}
